import { SuiClient, type CoinBalance } from '@mysten/sui/client';
import { defineModel } from 'foca';

interface BalanceStateStruct {
  balances: Record<string, CoinBalance[]>;
}

const initialState: BalanceStateStruct = {
  balances: {},
};

export const balanceModel = defineModel('balance-vault', {
  initialState,
  methods: {
    async getBalances(accountAddress: string, client: SuiClient) {
      const balances = await client.getAllBalances({
        owner: accountAddress,
      });
      this.setState((state) => {
        state.balances[accountAddress] = balances;
      });
    },
  },
});
